import * as actionTypes from "../actions/actionTypes";

const initialState = {
  coursesData: null,
};

const setCoursesData = (state, action) => {
  return {
    ...state,
    coursesData: action.data,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_COURSES_DATA_DONE:
      return setCoursesData(state, action);
    default:
      return state;
  }
};

export default reducer;
